/* Shopify owns delivery, recipient, CAPTCHA and spam filtering. No external endpoint. */
(() => {
  const fieldNames = { category: 'contact[Catégorie]', subject: 'contact[Sujet]', name: 'contact[name]', email: 'contact[email]', phone: 'contact[phone]', body: 'contact[body]', year: 'contact[Année du véhicule]' };
  const cleanLine = value => String(value || '').replace(/[\r\n\u0000-\u001f]/g, ' ').trim();
  let selectedVariantId = null;
  function safePageURL(value) {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/(products|pages|collections)\//.test(url.pathname) || url.username || url.password) return '';
      const variant = url.searchParams.get('variant');
      url.search = ''; url.hash = '';
      if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
      return url.href;
    } catch { return ''; }
  }
  function contactLinks() {
    const context = document.querySelector('[data-yz-page-context]');
    if (!context) return;
    document.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.href, window.location.origin); } catch { return; }
      const emailCTA = link.closest('main') && url.protocol === 'mailto:' && url.pathname.toLowerCase() === 'yzdetaling@gmail.com';
      if (emailCTA) url = new URL('/pages/contact', window.location.origin);
      if (url.origin !== window.location.origin || url.pathname !== '/pages/contact') return;
      if (!url.searchParams.has('category')) url.searchParams.set('category', link.dataset.yzContactCategory || context.dataset.category);
      url.searchParams.set('context_name', context.dataset.name);
      let pageURL = safePageURL(context.dataset.url);
      if (context.dataset.kind === 'product' && pageURL) {
        const variant = selectedVariantId ?? (new URL(window.location.href).searchParams.get('variant') || document.querySelector('form[action*="/cart/add"] [name="id"]')?.value);
        if (variant && /^\d+$/.test(variant)) { const selected = new URL(pageURL); selected.searchParams.set('variant', variant); pageURL = selected.href; }
      }
      url.searchParams.set('context_url', pageURL);
      if (!url.searchParams.has('subject')) url.searchParams.set('subject', `Question : ${context.dataset.name}`.slice(0, 180));
      link.href = url.href;
    });
  }
  function prepare(form) {
    if (form.dataset.yzReady) return;
    form.dataset.yzReady = 'true';
    const initialSuccess = form.querySelector('[data-yz-contact-success]');
    if (initialSuccess) { initialSuccess.focus({ preventScroll: true }); return; }
    const fields = Object.fromEntries(Object.entries(fieldNames).map(([key, name]) => [key, form.elements.namedItem(name)]));
    const button = form.querySelector('button[type="submit"]');
    const normalLabel = button.textContent.trim();
    const notice = form.querySelector('[data-yz-contact-notice]');
    const noticeText = form.querySelector('[data-yz-contact-notice-text]');
    const challenge = form.querySelector('[data-yz-contact-challenge]');
    const status = form.querySelector('[data-yz-send-status]');
    let busy = false, started = false, attempted = false, lastAccepted = 0, captchaTimeout;
    const alreadyProtected = form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound');
    form.noValidate = true;
    function error(input, message) {
      if (!input) return;
      const target = input.closest('.yz-request-field')?.querySelector('[data-yz-error]');
      if (target) { target.textContent = message; target.hidden = !message; }
      if (message) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }
    function messageFor(input) {
      if (input.disabled) return '';
      const value = input.value.trim();
      if (input.required && !value) {
        if (input === fields.category) return 'Choisissez la catégorie qui correspond à votre demande.';
        if (input === fields.name) return 'Indiquez votre nom et votre prénom.';
        if (input === fields.email) return 'Indiquez votre adresse e-mail pour que nous puissions vous répondre.';
        if (input === fields.subject) return 'Indiquez le sujet de votre demande.';
        return 'Écrivez votre message avant de l’envoyer.';
      }
      if (input === fields.email && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Indiquez une adresse e-mail valide, par exemple nom@domaine.fr.';
      if (input === fields.phone && value) {
        const digits = value.replace(/\D/g, '').length;
        if (digits < 7 || digits > 20 || !/^\+?[\d\s()./\-]+(?:\s*(?:ext\.?|poste|x|#)\s*\d+)?$/i.test(value)) return 'Utilisez un numéro de téléphone avec son indicatif si nécessaire, par exemple +33 6 12 34 56 78.';
      }
      if (input === fields.year && value && !/^\d{4}$/.test(value)) return 'Indiquez l’année avec quatre chiffres, par exemple 2018.';
      if (input.dataset.yzContextUrl !== undefined && value && !safePageURL(value)) return 'Indiquez le lien d’un produit ou d’une page sur yzdetailing.fr.';
      if (input.maxLength > 0 && input.value.length > input.maxLength) return `Limitez ce champ à ${input.maxLength.toLocaleString('fr-FR')} caractères.`;
      return '';
    }
    function updateCategory() {
      const kind = fields.category.selectedOptions[0]?.dataset.kind;
      form.querySelectorAll('[data-yz-conditional]').forEach(group => {
        const visible = group.dataset.yzConditional.split(' ').includes(kind);
        group.hidden = !visible;
        group.querySelectorAll('input').forEach(input => { input.disabled = !visible; if (!visible) error(input, ''); });
      });
    }
    function countMessage() { form.querySelector('[data-yz-message-count]').textContent = `${fields.body.value.length.toLocaleString('fr-FR')} / 10 000`; }
    function setBusy(value) {
      busy = value; button.disabled = value; button.textContent = value ? 'Envoi en cours…' : normalLabel;
      form.setAttribute('aria-busy', String(value));
      status.textContent = value ? 'Veuillez patienter pendant la validation de votre envoi.' : '';
    }
    function failure(message) {
      clearTimeout(captchaTimeout); setBusy(false); started = false;
      notice.hidden = false; noticeText.textContent = message; notice.focus();
    }
    const params = new URLSearchParams(window.location.search);
    const category = params.get('category');
    const matching = [...fields.category.options].find(option => option.value === category || option.dataset.kind === category);
    if (matching) fields.category.value = matching.value;
    if (params.get('subject') && !fields.subject.value) fields.subject.value = cleanLine(params.get('subject')).slice(0, 180);
    const contextURL = safePageURL(params.get('context_url'));
    const contextName = cleanLine(params.get('context_name')).slice(0, 600);
    if (contextURL && contextName) {
      const context = form.querySelector('[data-yz-context]'); context.hidden = false;
      context.querySelectorAll('input').forEach(input => { input.disabled = false; });
      form.querySelector('[data-yz-context-name]').value = contextName;
      form.querySelector('[data-yz-context-url]').value = contextURL;
    }
    updateCategory(); countMessage();
    fields.category.addEventListener('change', updateCategory);
    fields.body.addEventListener('input', countMessage);
    form.querySelectorAll('input,select,textarea').forEach(input => {
      input.addEventListener('blur', () => { if (attempted || input.value.trim()) error(input, messageFor(input)); });
      input.addEventListener('input', () => { if (input.getAttribute('aria-invalid') === 'true') error(input, messageFor(input)); });
    });
    // Install before Shopify wires CAPTCHA. Its supported protect() wrapper keeps
    // ownership of token generation, then invokes this submission transport.
    // No direct calls to the underlying CAPTCHA library and no token bypass.
    async function transport() {
      if (!busy || started) return;
      started = true; clearTimeout(captchaTimeout);
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 30000);
      try {
        const payload = new FormData(form);
        for (const [name, value] of [...payload.entries()]) if (typeof value === 'string' && !value.trim() && name.startsWith('contact[')) payload.delete(name);
        const response = await fetch(form.action, { method: 'POST', body: new URLSearchParams(payload), credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
        const result = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sent = result.querySelector('[data-yz-contact-success]');
        if (response.ok && sent) {
          lastAccepted = Date.now();
          const confirmation = document.importNode(sent, true);
          form.replaceChildren(confirmation); form.setAttribute('aria-busy', 'false'); busy = false; confirmation.focus(); return;
        }
        const location = new URL(response.url);
        if (location.origin === window.location.origin && location.pathname === '/challenge') {
          challenge.href = location.href; challenge.hidden = false;
          failure('Une vérification antispam est nécessaire. Votre texte est conservé. Continuez la vérification pour terminer l’envoi.'); return;
        }
        const rejectedEmail = result.querySelector('input[name="contact[email]"][aria-invalid="true"]');
        if (rejectedEmail) error(fields.email, 'Cette adresse e-mail n’a pas été acceptée par Shopify. Vérifiez-la avant de réessayer.');
        failure(response.status === 429 ? 'Trop de tentatives rapprochées. Patientez quelques instants puis réessayez. Votre message est conservé.' : 'Shopify n’a pas confirmé l’envoi. Votre message est conservé : vérifiez les informations puis réessayez.');
      } catch {
        failure('La connexion a été interrompue et nous n’avons pas pu confirmer l’envoi. Votre texte est conservé. Vous pouvez réessayer.');
      } finally { window.clearTimeout(timeout); }
    }
    // A late-loaded asset must preserve a CAPTCHA wrapper that already exists.
    // In this case Shopify performs the regular native navigation instead.
    if (!alreadyProtected) form.submit = transport;
    window.addEventListener('pageshow', event => {
      if (event.persisted && busy) failure('L’envoi n’a pas été confirmé. Votre texte est conservé. Vous pouvez réessayer.');
    });
    form.addEventListener('submit', event => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy || lastAccepted) return;
      attempted = true;
      const inputs = [...form.querySelectorAll('input,select,textarea')].filter(input => !input.disabled && input.type !== 'hidden' && !input.hasAttribute('data-yz-honeypot'));
      let firstError;
      for (const input of inputs) { const message = messageFor(input); error(input, message); if (message && !firstError) firstError = input; }
      if (firstError) { firstError.focus(); return; }
      if (form.querySelector('[data-yz-honeypot]').value) { failure('La demande n’a pas été validée. Rechargez cette page avant de réessayer.'); return; }
      if (!navigator.onLine) { failure('Vous semblez être hors connexion. Votre message est conservé. Reconnectez-vous puis réessayez.'); return; }
      fields.email.value = fields.email.value.trim(); notice.hidden = true; challenge.hidden = true; setBusy(true);
      captchaTimeout = window.setTimeout(() => { if (!started) failure('La vérification antispam n’a pas pu aboutir. Votre texte est conservé : vérifiez votre connexion puis réessayez.'); }, 60000);
      const protection = window.Shopify?.captcha;
      if (protection?.protect) {
        try { protection.protect(form, () => { if (busy && !started) form.submit(); }); }
        catch { failure('La protection antispam n’est pas disponible. Votre texte est conservé. Réessayez dans quelques instants.'); }
      } else transport();
    }, true);
  }
  function init() { contactLinks(); document.querySelectorAll('form[data-yz-contact]').forEach(prepare); }
  // Defer scripts run before DOMContentLoaded: the transport must exist before
  // Shopify captures form.submit while wiring its native protection.
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('change', event => {
    if (!document.querySelector('[data-yz-page-context][data-kind="product"]')) return;
    const picker = event.target.closest?.('variant-picker[data-template-product-match="true"]');
    if (picker) {
      const option = event.target instanceof HTMLSelectElement ? event.target.selectedOptions[0] : event.target;
      // Horizon exposes the exact combination on the selected option before
      // its asynchronous section update refreshes the cart form's hidden ID.
      const variant = option?.dataset.variantId;
      selectedVariantId = /^\d+$/.test(variant || '') ? variant : '';
    }
    contactLinks();
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (link && /\/pages\/contact(?:[?#]|$)/.test(link.href)) contactLinks();
  });
})();
